import { render, staticRenderFns } from "./page-promocode-history.vue?vue&type=template&id=5160ffbb"
import script from "./page-promocode-history.vue?vue&type=script&lang=ts"
export * from "./page-promocode-history.vue?vue&type=script&lang=ts"
import style0 from "./page-promocode-history.vue?vue&type=style&index=0&id=5160ffbb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports